import React, { Component } from 'react'
import Link from '@components/Link'

import {
  playlistHeader,
  textRight
} from './style'

class PlaylistHeader extends Component {

  render() {
    const { showTitle, viewAllText, title, showViewAll, viewAllLink, alignRight } = this.props
    return (
      <div className={`${playlistHeader} ${alignRight && textRight}`}>
        {showTitle && (
          <div>
            <h3>{title}</h3>
          </div>
        )}
        {showViewAll && (
          <Link to={viewAllLink}>{viewAllLink && viewAllText || 'View All'}</Link>
        )}
      </div>
    )
  }
}

export default PlaylistHeader